import useDocumentTitle from '@/hooks/useDocumentTitle';
import { useLayoutPreferences } from '@/hooks/useLayoutPreferences';
import OverlayPanel from '@/components/ui/OverlayPanel';
import PatientDetail from './patientDetail/PatientDetail.tsx';
import { PatientDetailPanel } from '@patientMenu/PatientDetailPanel.tsx';
import { Patients } from '@patientMenu/patients/Patients.tsx';
import { useNavigate, useParams } from 'react-router-dom';
import { cn } from '@/lib/utils';

export function PatientsMenu() {
  const navigate = useNavigate();
  const { patientId } = useParams<{ patientId?: string }>();
  const { patientDetailLayout } = useLayoutPreferences();

  useDocumentTitle(!patientId ? 'Patients' : null);

  const handleClosePatient = () => {
    navigate('/patients');
  };

  const isSplitDetail = patientDetailLayout === 'split' && Boolean(patientId);
  const isOverlayDetail = patientDetailLayout === 'overlay' && Boolean(patientId);

  return (
    <div className="flex h-full min-h-0 w-full flex-col overflow-hidden rounded-xl noise p-3">
      <div className={cn('flex min-h-0 flex-1 gap-3', isSplitDetail && 'flex-row items-stretch')}>
        <Patients
          className={cn('min-h-0', isSplitDetail ? 'w-1/2 shrink-0' : 'w-full flex-1')}
          tableClassName={isSplitDetail ? 'min-h-0 flex-1 !h-full' : undefined}
        />

        {isSplitDetail && <PatientDetailPanel className="w-1/2 shrink-0" onClose={handleClosePatient} />}
      </div>

      {isOverlayDetail && (
        <OverlayPanel onClose={handleClosePatient} title="Patient overview" size="patientDetail">
          <PatientDetail />
        </OverlayPanel>
      )}
    </div>
  );
}
